import { render, staticRenderFns } from "./text-underline3.vue?vue&type=template&id=9d2b45fe&scoped=true&"
var script = {}
import style0 from "./text-underline3.vue?vue&type=style&index=0&id=9d2b45fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2b45fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d2b45fe')) {
      api.createRecord('9d2b45fe', component.options)
    } else {
      api.reload('9d2b45fe', component.options)
    }
    module.hot.accept("./text-underline3.vue?vue&type=template&id=9d2b45fe&scoped=true&", function () {
      api.rerender('9d2b45fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-underline3.vue"
export default component.exports